import React from 'react';
import { FiAlertCircle, FiLoader, FiInbox, FiClock } from 'react-icons/fi';
import './ParentBackendPendingBanner.css';

/**
 * Uniform loading/error/empty/pending renderer for parent widgets.
 * `pending` = the backend endpoint doesn't exist yet; see BACKEND_GAPS.md.
 */
function ParentBackendPendingBanner({ state, message, hint }) {
  const cfg = STATE_CONFIG[state] || STATE_CONFIG.empty;
  const Icon = cfg.icon;
  return (
    <div className={`parent-pending-banner parent-pending-banner--${state}`} role="status">
      <Icon size={18} className="parent-pending-banner__icon" aria-hidden="true" />
      <div className="parent-pending-banner__body">
        <p className="parent-pending-banner__message">{message || cfg.defaultMessage}</p>
        {hint && <p className="parent-pending-banner__hint">{hint}</p>}
      </div>
    </div>
  );
}

const STATE_CONFIG = {
  loading: { icon: FiLoader, defaultMessage: 'Loading…' },
  error: { icon: FiAlertCircle, defaultMessage: 'Something went wrong.' },
  empty: { icon: FiInbox, defaultMessage: 'Nothing here yet.' },
  pending: { icon: FiClock, defaultMessage: 'Backend endpoint pending.' },
};

export default ParentBackendPendingBanner;
